export var PPA_LABEL = 'state';
export var COMING_SOON = 'ComingSoon';
export var LAST_CHANCE = 'LastChance';
export var LOW_STOCK = 'LowStock';
export var NO_LONGER_FOR_SALE = 'NoLongerForSale';
export var NOT_SOLD_ONLINE = 'NotSoldOnline';
export var OUT_OF_STOCK = 'OutOfStock';
export var SALE_LIMITATION = 'SaleLimitation';
export var SOLD_OUT = 'SoldOut';
export var UNTIL_STOCK_LASTS = 'UntilStockLasts';
export var VALUE_SET = 'ValueSet';
//# sourceMappingURL=ppaLabel.js.map